import cn from "classnames"
import IconLeft from "./IconLeft"
import IconRight from "./IconRight"
import IconFullScreen from "./IconFullScreen"

const buttonsPrevNextSharedClasses = (enabled) =>
  cn(
    {
      "focus:outline-none": enabled,
      hidden: !enabled,
    },
    "absolute h-full top-1/2 opacity-75 hover:opacity-100 my-tap-highlight"
  )

export const PrevButton = ({enabled, onClick}) => (
  <button
    className={`${buttonsPrevNextSharedClasses(enabled)} left-0`}
    onClick={onClick}
    style={{transform: "translateY(-50%)"}}
    aria-label="Vorheriges Bild"
  >
    <IconLeft />
  </button>
)

export const NextButton = ({enabled, onClick}) => (
  <button
    className={`${buttonsPrevNextSharedClasses(enabled)} right-0`}
    style={{transform: "translateY(-50%)"}}
    onClick={onClick}
    aria-label="Nächstes Bild"
  >
    <IconRight />
  </button>
)

export const ToggleFullScreenButton = ({onClick}) => (
  <button
    className="absolute bottom-0 right-0 opacity-75 focus:outline-none hover:opacity-100 my-tap-highlight"
    onClick={onClick}
    aria-label="Vollbildmodus"
  >
    <IconFullScreen />
  </button>
)
